import { render, staticRenderFns } from "./updatePass.vue?vue&type=template&id=2d1d1405&scoped=true&"
import script from "./updatePass.vue?vue&type=script&lang=js&"
export * from "./updatePass.vue?vue&type=script&lang=js&"
import style0 from "./updatePass.vue?vue&type=style&index=0&id=2d1d1405&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d1405",
  null
  
)

export default component.exports